import httpService from "@/components/service";
import { clearLocalStorage } from "@/utils/storage";
import http from "@/services/http";
import { buildUrlFromLocation } from "@/utils/httpUtils";
import session from "@/services/session";

export default {
    async logout() {
        await httpService.fetch("POST", "/logout");
        clearLocalStorage();
        session.clearSession();
        window.location.replace("/");
    },
    async create(user) {
        return await http.post(buildUrlFromLocation("/admin/manager/user/add"), user);
    },
    async update(id, user) {
        return await http.post(buildUrlFromLocation("/admin/manager/user/" + id + "/user-brand"), user);
    },
    async edit(user) {
        return await http.post(buildUrlFromLocation("/admin/manager/user/" + user.id + "/edit"), user);
    },
    async resetLoginAttempts(userId) {
        return await http.post(buildUrlFromLocation("/resetLoginAttempts/" + userId, { campaignId: null }));
    },
    async getProfiles() {
        return await http.get(buildUrlFromLocation(`/admin/profiles`, { campaignId: null }));
    },
    async getProfileWithAccess(id) {
        return await http.get(buildUrlFromLocation(`/admin/profiles/${id}/access`, { campaignId: null }));
    },
    async getProfile(id) {
        return await http.get(buildUrlFromLocation(`/admin/profiles/${id}`, { campaignId: null }));
    },
    async getUsersByZone(zoneId) {
        return await http.get(buildUrlFromLocation(`/admin/zone/${zoneId}/users`, { campaignId: null }));
    },
    async createProfile(payload) {
        return await http.post(buildUrlFromLocation(`/admin/profiles`, { campaignId: null }), payload);
    },
    async updateProfile(profile) {
        return await http.put(buildUrlFromLocation(`/admin/profiles/${profile.id}`, { campaignId: null }), profile);
    },
    async updateProfileAccess(profile, access) {
        return await http.put(buildUrlFromLocation(`/admin/profiles/${profile.id}/access`, { campaignId: null }), { accessProfile: access });
    },
    getRoles() {
        return httpService.get("/roles");
    },
    async godMode() {
        return await http.get(buildUrlFromLocation(`/admin/users/god-mode`, { campaignId: null }));
    }
};



// WEBPACK FOOTER //
// ./src/services/user.js